<app-ngb-timepicker
  class="time-picker"
  [ngModel]="context.data[context.column.columnDef]"
  [disabled]="!context.cell.allowEditing"
  (focusout)="onEndEdit()"
  (ngModelChange)="onChange($event)"
></app-ngb-timepicker>
